import { JoinSacSpecialist } from 'domain/usecases/sacSpecialist/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteJoinSacSpecialist implements JoinSacSpecialist {
  private readonly url: string;

  private readonly httpClient: HttpClient<JoinSacSpecialist.Model>;

  constructor(url: string, httClient: HttpClient<JoinSacSpecialist.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  join = async (
    params: JoinSacSpecialist.Params,
  ): Promise<JoinSacSpecialist.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{userId}', params.userId.toString()),
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
